$(document).ready(function() {
  $(document).on('click', '.clients-momentum-planning-validation-component .radio-buttons__option', function() {
    const component = $(this).closest('.clients-momentum-planning-validation-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_validation_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateValidationSection(id, property, value);
  });

  function updateValidationSection(id, property, value) {
    $.post('/components/clients/momentum_sections/validation', { id: id, property: property, value: value }).done(function(data) {
      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'validation');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
